import { toast } from 'react-hot-toast'
import { useCarromm } from '../../context/carrom'
import { useEffect, useState } from 'react'
import { CLOUD_URL } from '../../constants/common.constants'
import { validateImage } from 'image-validator'

const ImgBox = ({ imageUrl, wapperCss, imageCss }) => {
  const carrom = useCarromm()
  const [proxyImageUrl, setProxyImageUrl] = useState(imageUrl)
  useEffect(() => {
    setProxyImageUrl(imageUrl)
  }, [imageUrl])
  const handledata = async e => {
    e.preventDefault()
    // eslint-disable-next-line
    if (e?.type == 'error') {
      const isImage = await validateImage(imageUrl)
      if (!!isImage) {
        setProxyImageUrl(
          `${CLOUD_URL}/proxy-image?url=${encodeURIComponent(imageUrl)}`
        )
      } else {
        const newPreviewImages = carrom?.previewImages.slice(0, -1)
        const newHoldFile = carrom?.holdFile.slice(0, -1)
        carrom?.setPreviewImages(newPreviewImages)
        carrom?.setHoldFile(newHoldFile)
        toast(`Invalid file type. Only image files are allowed.`)
      }
      //   toast(`Oops! We couldn't load the image you requested due to a security restriction.`)
    }
  }
  return (
    <div className={`${wapperCss ? wapperCss : 'car-img-box'}`}>
      <div id='msg'></div>
      <img
        className={`${imageCss ? imageCss : 'w-full h-180 object-cover'}`}
        onError={e => handledata(e)}
        crossOrigin='anonymous'
        width={200}
        height={200}
        src={proxyImageUrl}
        alt={imageUrl}
      />
    </div>
  )
}

export default ImgBox
